import { Params, RouterStateSnapshot } from '@angular/router';
import { RouterStateSerializer } from '@ngxs/router-plugin';

export interface RouterStateParams {
  url: string;
  urlTemplate: string;
  params: Params;
  queryParams: Params;
  data: Params;
}

// Map the router snapshot to { url, params, queryParams }
export class WizbiiRouterStateSerializer implements RouterStateSerializer<RouterStateParams> {
  serialize(routerState: RouterStateSnapshot): RouterStateParams {
    const { url } = routerState;
    let urlTemplate = '';

    let { root: route } = routerState;

    while (route.firstChild) {
      route = route.firstChild;
      if (route.routeConfig.path !== '') {
        urlTemplate += `/${route.routeConfig.path}`;
      }
    }

    const { params, queryParams, data } = route;

    return {
      url,
      urlTemplate,
      params,
      queryParams,
      data,
    };
  }
}
